import styles from "./ConfirmPopup.module.scss";
import React from "react";
import { useTranslation } from "react-i18next";
import CustomButton from "../ui/CustomButton/CustomButton";
import defaultIcon from "../../assets/images/icons/confirm-popup.svg";

interface IConfirmPopupProps {
  iconPath?: string;
  title: string;
  onClickYes: () => void;
  onClickNo: () => void;
}

const ConfirmPopup: React.FC<IConfirmPopupProps> = ({
  iconPath = defaultIcon,
  title,
  onClickYes,
  onClickNo,
}) => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.popup}>
        <img className={styles.image} src={iconPath} alt={"icon"} />
        <h3 className={styles.title}>{title}</h3>
        <div className={styles.btnWrapper}>
          <CustomButton
            text={t("No")}
            type={"button"}
            typeStyle={"outline"}
            functionOnClick={onClickNo}
          />
          <CustomButton
            text={t("Yes")}
            type={"button"}
            typeStyle={"fill"}
            functionOnClick={onClickYes}
          />
        </div>
      </div>
    </div>
  );
};

export default ConfirmPopup;
